module.exports = __webpack_public_path__ + "img/visit_old.9405af45.png";